import { useRef, useState } from "react";
import { Loader2, UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { importScormSequences } from "./ScormImportButton";

/** Zone de dépôt multi-fichiers : packages SCORM (.zip) → séquences ajoutées au module. */
export function ScormDropzone({ api, lessonId, onImported, compact = false }) {
  const ref = useRef(null);
  const [over, setOver] = useState(false);
  const [prog, setProg] = useState(null);

  const handle = async (fileList) => {
    const files = Array.from(fileList || []).filter((f) => /\.zip$/i.test(f.name));
    if (!files.length) return toast.error("Déposez des packages SCORM au format .zip");
    setProg(0);
    try {
      const d = await importScormSequences(api, files, { lessonId, onProgress: setProg });
      toast.success(`${d.imported} séquence${d.imported > 1 ? "s" : ""} SCORM ajoutée${d.imported > 1 ? "s" : ""}`);
      onImported?.(d);
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setProg(null);
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); handle(e.dataTransfer.files); }}
      onClick={() => prog === null && ref.current?.click()}
      className={`cursor-pointer rounded-xl border-2 border-dashed text-center transition-colors ${compact ? "p-3" : "p-6"} ${over ? "border-[#f7c935] bg-[#f7c935]/5" : "border-white/10 hover:border-sky-500/40 bg-[#0b0811]"}`}
      data-testid="cm-dropzone"
    >
      <input ref={ref} type="file" multiple accept=".zip,application/zip" className="hidden" data-testid="cm-dropzone-input" onChange={(e) => { handle(e.target.files); e.target.value = ""; }} />
      {prog !== null ? (
        <div className="flex items-center justify-center gap-2 text-sm text-white" data-testid="cm-dropzone-progress"><Loader2 className="w-4 h-4 animate-spin text-[#f7c935]" /> Import des packages… {prog}%</div>
      ) : (
        <>
          <UploadCloud className={`mx-auto text-sky-400 ${compact ? "w-5 h-5 mb-1" : "w-8 h-8 mb-2"}`} />
          <div className="text-sm font-bold text-white">Glissez-déposez vos packages SCORM (.zip)</div>
          <div className="text-[11px] text-slate-500 mt-0.5">ou cliquez pour choisir plusieurs fichiers — SCORM 1.2 et 2004, 200 Mo max par package. Chaque package devient une séquence, dans l'ordre des fichiers.</div>
        </>
      )}
    </div>
  );
}
